import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface HollowBeamIconProps {
  size?: number;
  color?: string;
}

const HollowBeamIcon: React.FC<HollowBeamIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-hollowbeam">
    {
      <path d="M12 2.934c-5.007 0-9.066 4.059-9.066 9.066s4.059 9.066 9.066 9.066 9.066-4.059 9.066-9.066-4.059-9.066-9.066-9.066zM12 19.897c-4.361 0-7.897-3.535-7.897-7.897s3.535-7.897 7.897-7.897 7.897 3.535 7.897 7.897-3.535 7.897-7.897 7.897z"></path>
    }  </SvgIcon>
);

export default HollowBeamIcon;
